export default "__VITE_ASSET__Copa4ftm__"